export default __webpack_public_path__ + "static/media/horizontal-scroll.567606f9.png";